/**
 * useJobList Hook
 *
 * React Query hook for fetching the paginated job list with optional filters.
 * Re-fetches automatically whenever the filter params change.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import type { JobListParams } from '../api/jobListApi';
import { getJobList } from '../api/jobListApi';

export function useJobList(params: JobListParams = {}) {
  const queryKey = queryKeys.jobs.list(params);

  const query = useQuery({
    queryKey,
    queryFn: () => getJobList(params),
    staleTime: 30 * 1000, // 30 seconds — job list changes frequently
    gcTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    status: query.status,
  };
}
